import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- replace with crystal-ui
import { makeStyles, Box, Dialog, DialogContent, Typography, GRAY, IconButton, VIOLET } from '@applyboard/ui-components';
import { info_outline } from "../../../../../../assets/images/Results";
import CloseButtonCore from "../../../CloseButton/CloseButtonCore";
var useStyles = makeStyles({
  content: {
    padding: '0px !important'
  },
  close: {
    padding: '6px 0'
  },
  button: {
    paddingLeft: '10px',
    paddingTop: 0,
    top: '4px'
  }
});
var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
    _ref$PaperProps = _ref.PaperProps,
    PaperProps = _ref$PaperProps === void 0 ? null : _ref$PaperProps;
  var classes = useStyles();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var handleOpen = function handleOpen() {
    setOpen(true);
  };
  var handleClose = function handleClose() {
    setOpen(false);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconButton, {
    onClick: handleOpen,
    className: classes.button
  }, /*#__PURE__*/React.createElement("img", {
    alt: "",
    src: info_outline
  })), /*#__PURE__*/React.createElement(Dialog, {
    onClose: handleClose,
    "aria-labelledby": "simple-dialog-title",
    open: open,
    PaperProps: {
      style: {
        width: "".concat(PaperProps ? PaperProps.width : null),
        height: "".concat(PaperProps ? PaperProps.height : null),
        borderRadius: '8px',
        padding: '16px'
      }
    }
  }, /*#__PURE__*/React.createElement(DialogContent, {
    className: classes.content
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex"
  }, /*#__PURE__*/React.createElement(Box, {
    width: 1
  }, children), /*#__PURE__*/React.createElement(Box, {
    width: "32px",
    className: classes.close
  }, /*#__PURE__*/React.createElement(CloseButtonCore, {
    onClick: handleClose
  }))))));
};
export var AcceptedTestsTooltip = function AcceptedTestsTooltip() {
  return /*#__PURE__*/React.createElement(Tooltip, {
    PaperProps: {
      width: '323px',
      height: '248px'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph",
    style: {
      color: VIOLET[13]
    }
  }, "This program accepts any of the following English language proficiency tests."), /*#__PURE__*/React.createElement(Typography, {
    style: {
      color: GRAY[5]
    }
  }, "This program has nationality-specific English requirements and hence, scores here may be different from those displayed in the Admissions Requirements section."));
};